import AvailableAddons from './AvailableAddons';

export default AvailableAddons;
